<template>
  <section v-scroll="onScroll" id="program-info" class="grey lighten-3">
    <v-navigation-drawer v-show="toolbar" fixed temporary v-model="drawer">
      <v-toolbar flat>
        <v-list>
          <v-list-tile>
            <v-list-tile-title class="title">
              清大學程小幫手
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-divider/>
      <v-list dense class="pt-0">
        <v-list-tile v-for="m in menus" :key="m.name" @click="active(m.name)">
          <v-list-tile-action>
            {{ `${m.doneCredit}/${m.minCredit}` }}
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ m.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar id="toolbar" v-show="toolbar" fixed dark>
      <v-toolbar-side-icon @click="drawer = !drawer"/>
      <v-toolbar-title>{{ root.name }}</v-toolbar-title>
    </v-toolbar>
    <v-container grid-list-md style="max-width: 750px">
      <v-layout column class="mb-4 px-1 py-1">
        <h2 class="display-1 mb-2">{{ root.name }}</h2>
        <h4 class="mb-2" :class="{'pink--text': !root.valid}">{{ `至少 ${root.minCredit} 學分，已修 ${root.doneCredit} 學分` }}</h4>
        <v-select
          :items="settingsItems"
          v-model="settings"
          label="顯示設定"
          multiple
          hide-details
          prepend-icon="visibility"
          max-height="400"/>
        <div>
        </div>
      </v-layout>
      <v-layout justify-center column>
        <v-flex x12 class="my-3" v-for="(cat, i) in root.categories" :key="i">
          <h2 class="mb-2" :class="{'pink--text': !cat.valid}">{{ cat.description }}</h2>
          <v-list expand class="program-info-list py-0 elevation-1">
            <v-subheader>{{ `已修 ${cat.doneCourse} 門課（${cat.doneCredit} 學分）` }}</v-subheader>
            <v-list-group v-for="(tbl, i) in cat.tables" :key="i">
              <v-list-tile slot="activator">
                <v-list-tile-action>
                  <v-icon :class="{'pink--text': !tbl.valid && !cat.valid}">{{ numberIcons[i] }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ tbl.description }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-subheader inset class="pl-0">{{ `已修 ${tbl.doneCourse} 門課（${tbl.doneCredit} 學分）` }}</v-subheader>
              <program-list-item
                v-for="d in tbl.done"
                :key="d.name"
                :item="{name: d.name, credits: [d.credit], records: [d.record], isEnrolled: true}"
                :settings="settings"/>
              <v-divider inset></v-divider>
              <v-subheader inset class="pl-0">可選</v-subheader>
              <template v-for="(r, i) in tbl.rest">
                <program-list-item
                  v-if="!r.group && (!hideNotDeliveredInYear || r.deliveredInYear) && (!hideNotDeliveredThisSemester || r.deliveredThisSemester)"
                  :key="r.name"
                  :item="r"
                  :settings="settings"/>
                <v-list-group
                  v-else-if="r.group && (!hideNotDeliveredInYear || r.deliveredInYear.includes(true)) && (!hideNotDeliveredThisSemester || r.deliveredThisSemester.includes(true))"
                  subGroup
                  :key="i">
                  <v-list-tile slot="activator">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ `${r.description}：${r.names.join('／')}` }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <program-list-item
                    v-for="(n, i) in r.names"
                    :key="i"
                    v-if="(!hideNotDeliveredInYear || r.deliveredInYear[i]) && (!hideNotDeliveredThisSemester || r.deliveredThisSemester[i])"
                    :item="{name: n, credits: r.credits[i], records: r.records[i]}"
                    :settings="settings"/>
                </v-list-group>
              </template>
            </v-list-group>
          </v-list>       
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { SET_ACTIVE_PROGRAM } from '../store/constants';
import ProgramListItem from './ProgramListItem';

const numberIcons = [
  'looks_one',
  'looks_two',
  'looks_3',
  'looks_4',
  'looks_5',
  'looks_6',
];

const settingsItems = [
  '顯示學分',
  '顯示開設學期',
  '顯示開設系所',
  '僅顯示本學期（107 上）開設之課程',
  '僅顯示一年內有開設之課程',
];

export default {
  name: 'program-info',
  components: {
    'program-list-item': ProgramListItem,
  },
  data() {
    return {
      settingsItems,
      settings: [
        '顯示學分',
        '僅顯示一年內有開設之課程',
      ],
      toolbar: false,
      drawer: false,
      numberIcons,
    }
  },
  computed: {
    ...mapState(['programs', 'activeProgram']),
    ...mapGetters(['menus']),
    root() {
      return this.programs[this.activeProgram];
    },
    hideNotDeliveredInYear() {
      return this.settings.includes('僅顯示一年內有開設之課程');
    },
    hideNotDeliveredThisSemester() {
      return this.settings.includes('僅顯示本學期（107 上）開設之課程');
    },
  },
  methods: {
    ...mapActions([SET_ACTIVE_PROGRAM]),
    onScroll() {
      this.toolbar = this.$el.getBoundingClientRect().top < 0;
    },
    active(name) {
      this.drawer = false;
      this[SET_ACTIVE_PROGRAM](name);
    },
  },
}
</script>

<style lang="scss">
#toolbar {
  @media only screen and (min-width: 960px) {
    .v-toolbar__content {
      padding: 0 calc((100% - 750px) / 2 + 24px);
    }
  }

  @media only screen and (min-width: 750px) and (max-width: 959px) {
    .v-toolbar__content {
      padding: 0 calc((100% - 750px) / 2 + 16px);
    }
  }
}

.program-info-list {
  .v-list__tile {
    padding-left: 0 !important;
  }

  .v-list__tile__action {
    justify-content: center !important;
  }

  .v-list__group__header--sub-group .v-list__group__header__prepend-icon {
    padding-left: 24px !important;
    margin-right: 0 !important;
  }

  .v-subheader {
    display: flex !important;
  }

  .v-divider--inset:not(.v-divider--vertical) {
    margin-left: 56px !important;
    max-width: calc(100% - 56px) !important;
  }
}

.v-list__group__header > div {
  max-width: calc(100% - 56px);
}



</style>
